import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class DolarService {
  public company: string;

  constructor(
    private _http: HttpClient
  ) {
    this.company = localStorage.getItem('TOKEN');
  }

  getDolarBluePrice(): Observable<any> {
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this._http.get(`https://api-dolar-argentina.herokuapp.com/api/dolarblue`);
  }
}